// Forma para llenar reportes

import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  TextField,
  Typography,
  Grid
} from '@mui/material';
import {
  FIELD_LABELS,
  emailValidator,
  nameValidator,
  numbersOnlyValidator,
  phoneValidator,
  requiredValidator,
  rfcValidator,
  streetNameValidator,
  validateField
} from '../validators';
import { useUser } from '../UserContext';
import { apiFetchJson } from '../fetchWrapper';
import { getReportStatusLabel, getReportStatuses } from './ReportStatus';

export default function ReportForm({ report, onCancel, onSave }) {
  const initialForm = {
    id: 0,
    siteId: 0,
    latitude: 0,
    longitude: 0,
    siteId: 0,
    authorId: 0,
    subject: "",
    description: "",
    reportStatus: "NEW",
    assignedToId: 0,
  };
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [sites, setSites] = useState([]);
  const [employees, setEmployees] = useState([]);
  const { user, setUser } = useUser();
  const hasErrors = Object.keys(errors).length > 0;

  const requiredFields = [
    'subject',
    'description',
    'siteId'
  ];

  const missingRequiredFields = requiredFields.filter((field) => {
    const value = form[field];
    return value === undefined || value === null || value === '' || value === 0;
  });

  const requiredFieldsFilled = missingRequiredFields.length === 0;


  useEffect(() => {
    apiFetchJson("/api/sites").then(setSites);
    apiFetchJson("/api/employees").then(setEmployees);
  }, []);

  useEffect(() => {
    if (report) {
      setForm({
        id: report.id,
        latitude: report.latitude,
        longitude: report.longitude,
        siteId: report.siteId,
        authorId: report.authorId,
        assignedToId: report.assignedToId,
        subject: report.subject,
        description: report.description,
        reportStatus: report.reportStatus,
        assignedToId: report.assignedToId,
      });
    } else {
      setForm(initialForm);
    }
  }, [report]);

  // const handleChange = (e) => {
  //   const { name, value, checked, type } = e.target;
  //   setForm((prev) => ({ ...prev, [name]: value }));
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      id: form.id,
      latitude: 0,
      longitude: 0,
      siteId: form.siteId,
      authorId: user.id,
      subject: form.subject,
      assignedToId: form.assignedToId,
      description: form.description,
      reportStatus: form.reportStatus
    };

    try {
      const method = report ? 'PUT' : 'POST';
      const url = report
        ? `/api/reports/${report.id}`
        : `/api/reports`;
      console.log('Submitting report to', url, 'method', method, 'with payload', payload);
      const resJson = await apiFetchJson(url, {
        method,
        body: JSON.stringify(payload),
      });

      const savedReport = await resJson;
      console.log('Report saved successfully', savedReport);
      onSave(savedReport);
    } catch (err) {
      console.error('Failed to save report', err);
      alert('Error al guardar el reporte');
    }
  }


  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    setErrors(prev => {
      const next = { ...prev };
      let error = null;
      if (name === 'subject' || name === 'siteId' || name === 'description') {
        error = validateField(value, [
          requiredValidator
        ]);
      }

      if (error) {
        next[name] = error;
      } else {
        delete next[name];
      }
      return next;
    });
  };

  return (
    <Card sx={{
      width: "100%",
      margin: '1rem auto',
      padding: 1,
      backgroundColor: '#f9f9f9',
    }}>
      <CardContent sx={{ pt: 2 }}>
        <Typography variant="subtitle1"
          sx={{
            mb: 2,
            fontSize: '16px',
            fontWeight: 600
          }}>
          Registro nuevo reporte
        </Typography>
        <form onSubmit={handleSubmit}>
          {/* <Box sx={{ mt: 1, mb: 2 }}> */}
          <Grid container spacing={2}>

            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                label="Asunto"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                error={!!errors.subject}
                helperText={errors.subject}
                slotProps={{ htmlInput: { maxLength: 255 } }}
                fullWidth
                required
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                select
                label="Ubicación"
                name="siteId"
                value={form.siteId}
                onChange={handleChange}
                error={!!errors.siteId}
                helperText={errors.siteId}
                fullWidth
                required
              >
                {sites.map((site) => (
                  <MenuItem key={site.id} value={site.id}>
                    {site.client.companyName} - {site.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <TextField
                label="Descripción"
                name="description"
                value={form.description}
                onChange={handleChange}
                error={!!errors.description}
                helperText={errors.description}
                fullWidth
                required
                multiline
                rows={4}
              />
            </Grid>
            {report && (
              <>
                <Grid size={{ xs: 12, md: 6 }}>
                  <TextField
                    select
                    label="Estado del reporte"
                    name="reportStatus"
                    value={form.reportStatus}
                    onChange={handleChange}
                    error={!!errors.reportStatus}
                    helperText={errors.reportStatus}
                    fullWidth
                    required
                  >
                    {getReportStatuses().map((status) => (
                      <MenuItem key={status.value} value={status.value}>
                        {status.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <TextField
                    select
                    label="Asignado a:"
                    name="assignedToId"
                    value={form.assignedToId}
                    onChange={handleChange}
                    error={!!errors.assignedToId}
                    helperText={errors.assignedToId}
                    fullWidth
                    required
                  >
                    {employees.map((employee) => (
                      <MenuItem key={employee.id} value={employee.id}>
                        {employee.id} {employee.user.person.firstname} {employee.user.person.lastnameFirst}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </>
            )}
          </Grid>
          {/* </Box> */}
          <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              onClick={onCancel}
              color="error"
            >
              Cancelar
            </Button>

            <Button
              sx={{
                backgroundColor: "#3f74b1",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#364f6b"
                }
              }}
              variant="contained"
              disabled={hasErrors || !requiredFieldsFilled}
              onClick={handleSubmit}>
              Guardar
            </Button>
          </CardActions>
        </form>
      </CardContent>
    </Card>
  );
}